import { AuthEffects } from './auth/auth.effects';
import { CompanyContactsEffects } from './company-contacts/company-contacts.effects';
import { DocumentationEffects } from './documentation/documentation.effects';

export const storeEffects = [
  AuthEffects,
  CompanyContactsEffects,
  DocumentationEffects,
];
